import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Cover lines as XXL-style sticker tags: each quote opens a tab on the site.
const LINES = [
  { quote: "Pop culture, side-eyed.", dest: "The Lowdown", kind: "The Feed", href: "/lowdown", rot: -1.5 },
  { quote: "Every morning, one word before the world gets loud.", dest: "Morning Glowgetters", kind: "Daily", href: "/morning", rot: 1.2 },
  { quote: "The letters that heal — you wrote, we listened.", dest: "Dear Glowgetters", kind: "The Letters", href: "/glowgetters", rot: -2 },
  { quote: "Charts don't lie. We just read them out loud.", dest: "Chart Watch", kind: "Live Board", href: "#charts", rot: 1 },
  { quote: "You made it. We're listening.", dest: "Submit Your Music", kind: "Open Call", href: "#submit", rot: -1 },
  { quote: "Wait… who is THIS? Meet the Artist to Know.", dest: "MaliGotBandz", kind: "Artist Spotlight", href: "/rhythm/spotlight-maligotbandz", rot: 1.6 },
];

export const CoverLines = () => (
  <div data-testid="rhythm-cover-lines" className="flex h-full flex-col">
    <p className="font-rhythm-mono text-[10px] uppercase tracking-[0.22em] text-white/50">
      On the cover — every quote opens a door
    </p>
    <div className="mt-4 flex flex-1 flex-col justify-between gap-4 sm:gap-5">
      {LINES.map((l, i) => {
        const inner = (
          <>
            <span className="flex items-baseline gap-3">
              <span className="shrink-0 font-rhythm-mono text-[10px] font-bold text-[#FF0055]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-garamond text-xl font-medium italic leading-snug text-[#0B0A0F] sm:text-2xl">
                "{l.quote}"
              </span>
              <ArrowUpRight className="ml-auto h-4 w-4 shrink-0 self-center text-[#FF0055] transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </span>
            <span className="mt-1.5 block pl-9 text-left font-rhythm-mono text-[9px] uppercase tracking-[0.2em] text-[#0B0A0F]/60">
              {l.dest} · {l.kind}
            </span>
          </>
        );
        const cls = `group block w-fit max-w-full border-2 border-[#0B0A0F]/80 bg-[#F3F1ED] px-4 py-3 shadow-[5px_6px_0_rgba(11,10,15,0.9)] transition-all duration-200 hover:rotate-0 hover:bg-[#FF0055] hover:shadow-[2px_3px_0_rgba(11,10,15,0.9)]`;
        return l.href.startsWith("/") ? (
          <Link
            key={l.dest}
            data-testid={`rhythm-cover-line-${i + 1}`}
            to={l.href}
            className={cls}
            style={{ rotate: `${l.rot}deg` }}
          >
            {inner}
          </Link>
        ) : (
          <a
            key={l.dest}
            data-testid={`rhythm-cover-line-${i + 1}`}
            href={l.href}
            className={cls}
            style={{ rotate: `${l.rot}deg` }}
          >
            {inner}
          </a>
        );
      })}
    </div>
  </div>
);

export default CoverLines;
